import { Button } from '@domain-group/suit-theme'

import useOAuthIntegration from '@hooks/useOAuthIntegration'
import { ComponentProps } from 'react'

/* Usage

<ButtonWithOauth
  authProviderKey="core_logic"
  buttonStyle="secondaryCreate"
  queryParams={{
    organization_id: selectedAgency.id,
    redirect: window.location.href,
  }}
  size="medium"
  width="auto"
>
  Connect
</ButtonWithOauth>

*/

type ButtonWithOAuthProps = ComponentProps<typeof Button> & {
  authProviderKey: string,
  queryParams: { [key: string]: any },
}

const ButtonWithOauth = (props: ButtonWithOAuthProps) => {
  const { authProviderKey, queryParams, ...buttonProps } = props

  const authPayload = useOAuthIntegration(authProviderKey, { queryParams })
  const {
    callbacks: { onClick }, csrfToken, href, formRef,
  } = authPayload

  return (
    <>
      {/*
       // @ts-expect-error TS2322 */}
      <form ref={formRef} action={href} method="post">
        <input type="hidden" name="authenticity_token" value={csrfToken} />
      </form>

      <Button onClick={() => onClick()} {...buttonProps} />
    </>
  )
}

export default ButtonWithOauth
